module.exports = __webpack_public_path__ + "static/EsperMission.en-3d83003e665beeb4e012ef865b74c2e2.svg";